import React, {useEffect} from "react";
import Countdown from "react-countdown";
import {useForceUpdate} from "../../../services/misc.functions";
import {homeHippodrome, homeHippodromeSubject, todayResults, todayResultsSubject} from "../../../store/misc.store";
import {useDailyRaces} from "../../../features/bulletin/bulletin.store";
import {selectHomeHippodrome} from "./hippodrome.cards";

export function DailyResults() {
    const forceUpdate = useForceUpdate();
    const dailyRaces = useDailyRaces();

    useEffect(() => {
        const homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe(() => forceUpdate());
        const todayResultsSubject_subscription = todayResultsSubject.subscribe(() => forceUpdate());
        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
            todayResultsSubject_subscription.unsubscribe();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hippodromes = dailyRaces.filter((hippodrome: any) => hippodrome.card_id != null);
    const results = todayResults[homeHippodrome?.keyword];

    return <div className={"daily-results"}>
        <div className={"daily-results-hippodromes"}>
            {hippodromes.map((hippodrome: any, index: number) => {
                return <button key={`daily-results-hippodrome-${index}`}
                               className={homeHippodrome?._id === hippodrome._id ? "active" : ""}
                               onClick={() => {
                                   selectHomeHippodrome(hippodrome);
                                   forceUpdate();
                               }}>{hippodrome.location}</button>
            })}
        </div>

        <table className={"daily-results-table"}>
            <thead>
            <tr>
                <th>#</th>
                <th>Atın Adı</th>
                <th>Ganyan</th>
                <th>AGF</th>
            </tr>
            </thead>
            <tbody>
            {homeHippodrome?.runs?.map((run: any, index: number) => {
                const winner = results?.runsMap?.[run.no]?.winnerHorse;
                const isNext = homeHippodrome?.nextRun?.no === run.no;
                return <tr key={`daily-results-run-${index}`}>
                    <td><span className={"daily-results-run"}>{run.no}.<small>KOŞU</small></span></td>
                    <td>
                        {winner
                            ? <span className={"daily-results-winner"}>{winner.no} - {winner.name}</span>
                            : isNext
                                ? <Countdown date={run.running_date} renderer={({completed}) => completed
                                    ? <span className={"daily-results-next"}>{run.time} - Başlamak Üzere</span>
                                    : <span className={"daily-results-time"}>{run.time}</span>}/>
                                : <span className={"daily-results-time"}>{run.time}</span>}
                    </td>
                    <td><span className={"daily-results-value"}>{winner ? winner.ganyan : "-"}</span></td>
                    <td><span className={"daily-results-value"}>{winner ? `%${winner.AGF1 ?? winner.AGF2}` : "-"}</span>
                    </td>
                </tr>
            })}
            </tbody>
        </table>
    </div>;
}
